import * as tslib_1 from "tslib";
import setupFavoritePersona from './setupFavoritePersona';
import { getStore } from 'owa-mail-favorites-store';
import { action } from 'satcheljs/lib/legacy';
import { synchronizePersonaSearchFolder, getFavoritePersonasRootFolderId, } from 'owa-mail-persona-search-folder-services';
/**
 * Update the search folder associated with the given persona. Create a new one if necessary.
 * Updates the current persona in the store with the new searchFolderId value
 * @param persona The persona whose search folder will be synced
 * @returns A promise wih a boolean value indicating whether a new search folder was generated
 */
export default action('synchronizeSearchFolder')(function synchronizeSearchFolder(persona, source, hasPersonaInformationChanged) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var state, parentFolderId, _a, searchFolderPersona, searchFolder, hasSearchFolderIdChanged;
        return tslib_1.__generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    state = getStore();
                    _a = state.favoritePersonasRootFolderId;
                    if (_a) return [3 /*break*/, 2];
                    return [4 /*yield*/, getFavoritePersonasRootFolderId()];
                case 1:
                    _a = (_b.sent());
                    _b.label = 2;
                case 2:
                    parentFolderId = _a;
                    searchFolderPersona = {
                        favoriteNodeId: persona.id,
                        displayName: persona.displayName,
                        allEmailAddresses: persona.allEmailAddresses,
                    };
                    return [4 /*yield*/, synchronizePersonaSearchFolder(searchFolderPersona, parentFolderId, source, hasPersonaInformationChanged)];
                case 3:
                    searchFolder = _b.sent();
                    hasSearchFolderIdChanged = persona.searchFolderId !== searchFolder.FolderId.Id;
                    setupFavoritePersona(searchFolder);
                    persona.isSyncUpdateDone = true;
                    return [2 /*return*/, hasSearchFolderIdChanged];
            }
        });
    });
});
//# sourceMappingURL=synchronizeSearchFolder.js.map